module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contact-view"
    }
  }, [_c('div', {
    attrs: {
      "id": "wideContent"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "boxContent"
  }, [_c('h1', [_vm._v("Kontakt")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "width": "470px",
      "src": require("../../../static/photos/contact/vchod.jpg")
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Lenka Holubová")]), _c('br'), _vm._v(" IČ: 49233629"), _c('br'), _vm._v("\n          Tel.: +420 723 222 400"), _c('br'), _vm._v(" E-mail: holubova@salonjaja.cz"), _c('br'), _vm._v("\n          Adresa: Pražského 662, Praha 5 - Hlubočepy (vchod z boku\n          domu)\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Stříhání dle telefonické domluvy.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "boxContent"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "500",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "src": "https://maps.google.com/maps?f=q&source=s_q&hl=cs&geocode=&q=Salon+J%C3%A1ja&aq=&sll=50.035564,14.380422&sspn=0.003042,0.008256&ie=UTF8&hq=Salon+J%C3%A1ja&hnear=&t=m&cid=14801085705193409773&z=14&iwloc=A&output=embed"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ac68545"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ContactView.vue
// module id = 75
// module chunks = 0